// extracted by mini-css-extract-plugin
export default {"confirmCardBtn":"_7-z","disabled":"a8-z","label":"b8-z"};